/**
 * Cone Selector Component
 * Handles validation for cone selection - disables add to cart until cones are selected.
 */

class ConeSelector {
  constructor() {
    this.init();
  }

  init() {
    // Find all cone selectors on the page
    document.querySelectorAll('[data-cone-selector]').forEach((container) => {
      const select = container.querySelector('select');
      const form = container.closest('form');

      if (!select || !form) return;

      // Find the add to cart button
      const addToCartButton = form.querySelector('[name="add"], .add-to-cart-button, button[type="submit"]');

      if (!addToCartButton) return;

      // Initial state - disable button if no cone selected
      this.updateButtonState(select, addToCartButton);

      // Listen for changes
      select.addEventListener('change', () => {
        this.updateButtonState(select, addToCartButton);
        container.classList.remove('cone-selector--error');
      });

      // Prevent form submission if no cone selected
      form.addEventListener('submit', (e) => {
        if (!select.value) {
          e.preventDefault();
          e.stopPropagation();
          container.classList.add('cone-selector--error');
          select.focus();
        }
      });
    });
  }

  updateButtonState(select, button) {
    // Check if cones are selected
    const isSelected = select.value !== '';

    // Only manage disabled state if it's related to cone selection
    // Don't override other disabled states (sold out, etc.)
    if (!isSelected) {
      button.dataset.coneNotSelected = 'true';
      // Don't disable directly - let the form validation handle it
    } else {
      delete button.dataset.coneNotSelected;
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ConeSelector());
} else {
  new ConeSelector();
}

// Re-initialize when sections are re-rendered (for Shopify theme editor)
document.addEventListener('shopify:section:load', () => new ConeSelector());
